export default "__VITE_ASSET__3Vf5wqm___"